import { Entity, stringifyEntityRef } from '@backstage/catalog-model';

/**
 * Links from the entity pages to the scaffolder (SR-06): app-relative paths
 * to `/create/templates/default/<fixed name>`, with `formData` built from
 * the current entity's ref and fixed enums only. The wizard opens with the
 * form pre-filled; nothing is submitted automatically.
 */

/** Scaffolder templates the entity pages open (AC-3). */
export const TEMPLATES = {
  /** Habilitar ambiente: `{ component, targetEnv }`. */
  promote: 'habilitar-ambiente-byx',
  /** Anexar infra existente: `{ component }`. */
  attachInfra: 'anexar-infra-byx',
} as const;

/** Environments that "Promover" can target, in order (backend rule). */
export const PROMOTION_TARGETS = ['staging', 'prod'] as const;

export type PromotionTarget = (typeof PROMOTION_TARGETS)[number];

/** `spec.type` of the templates in the Criar › Templates "Infraestrutura" group. */
export const INFRA_TEMPLATE_TYPE = 'resource';

function templatePath(name: string, formData: Record<string, string>) {
  return `/create/templates/default/${name}?formData=${encodeURIComponent(
    JSON.stringify(formData),
  )}`;
}

/** "Anexar existente": the attach template, pre-filled with the component. */
export function attachInfraPath(entity: Entity): string {
  return templatePath(TEMPLATES.attachInfra, {
    component: stringifyEntityRef(entity),
  });
}

/** "Promover": the enable-environment template for one target. */
export function promotePath(entity: Entity, targetEnv: PromotionTarget) {
  return templatePath(TEMPLATES.promote, {
    component: stringifyEntityRef(entity),
    targetEnv,
  });
}

/** "Criar recurso": Criar › Templates showing the Infraestrutura templates. */
export function createResourcePath(): string {
  const params = new URLSearchParams({ 'filters[type]': INFRA_TEMPLATE_TYPE });
  return `/create/templates?${params}`;
}

/**
 * True for a link that the backend writes as "Habilitar em <env>": it opens
 * the promote template, which "Promover" already offers.
 */
export function isPromoteLink(url: string): boolean {
  const target = `/create/templates/default/${TEMPLATES.promote}`;
  try {
    return new URL(url, 'https://app.invalid').pathname.endsWith(target);
  } catch {
    return false;
  }
}
